import dayjs from 'dayjs';
import { InvoiceInterface } from '../../interfaces/invoice.interface';
import { isDocTypeDeliveryNote } from './myDataUtils';

// Only relevant when `shipDate` is actually sent to myDATA at all - genuine delivery-note doc
// types, or any doc type with the "mark as delivery note" toggle on (mirrors the exact condition
// server-side, `getDispatchDateSection()` in `myDataInvoiceHeaderUtils.ts`).
export const isShipDateInThePast = (invoice: Partial<InvoiceInterface> | undefined): boolean => {
  if (!invoice?.shipDate) return false;
  const isShipDateRelevant = isDocTypeDeliveryNote(invoice?.documentType?.aadeCode || null) || invoice?.isDeliveryNote;
  if (!isShipDateRelevant) return false;

  return dayjs(invoice.shipDate).isBefore(dayjs(), 'day');
};

// myDATA's real-time invoicing model requires the issue date to be the actual day of
// transmission - a doc saved as a draft on one day and posted on a later one silently becomes
// invalid, the same staleness bug as `shipDate` above, just without a picker-level fix available
// (documentDate is restricted to today-or-later at creation time, but a draft can still sit
// unposted past midnight).
export const isDocumentDateNotToday = (invoice: Partial<InvoiceInterface> | undefined): boolean => {
  if (!invoice?.documentDate) return false;

  return !dayjs(invoice.documentDate).isSame(dayjs(), 'day');
};

// Returns the `API_ERRORS` translation key for the first pre-flight check that fails, or
// `undefined` if the doc is safe to post - lets `usePostSale()` catch the same staleness bugs
// myDATA would otherwise reject at transmission time, without a round trip. Checked in this order
// deliberately: a stale shipDate is the more specific/actionable problem, so it's surfaced first
// when both happen to be true at once.
export const getPostSalePreflightErrorCode = (invoice: Partial<InvoiceInterface> | undefined): string | undefined => {
  if (isShipDateInThePast(invoice)) return 'SHIP_DATE_INVALID';
  if (isDocumentDateNotToday(invoice)) return 'DOCUMENT_DATE_NOT_TODAY';

  return undefined;
};
